export var grid = function (container, children, config) {
    // todo
    return [];
};
//# sourceMappingURL=index.js.map